"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useState } from "react";
import { cx } from "../internal/cx.js";
import { IconChevronDown, IconChevronUp, IconInfo } from "../internal/icons.js";
import { IconList } from "./IconList.js";
/**
 * A short muted line with an icon; longer explanation hidden behind «Подробнее».
 * `details` as a list of lines is shown as a bulleted list (nothing for an empty list).
 */
export function Hint({ children, details: given, icon, moreLabel = "Подробнее", lessLabel = "Скрыть", className }) {
    const details = Array.isArray(given) ? (given.length ? _jsx(IconList, { items: [...given], marker: "bullet", tone: "text" }) : undefined) : given;
    const [open, setOpen] = useState(false);
    const id = useId();
    return _jsxs("div", { className: cx("jui-hint", className), children: [icon ?? _jsx(IconInfo, {}), _jsxs("div", { className: "jui-hint-body", children: [children, details && _jsxs("button", { type: "button", className: "jui-hint-toggle", "aria-expanded": open, "aria-controls": id, onClick: () => setOpen(!open), children: [open ? lessLabel : moreLabel, open ? _jsx(IconChevronUp, { small: true }) : _jsx(IconChevronDown, { small: true })] }), details && open && _jsx("div", { id: id, className: "jui-hint-details", children: details })] })] });
}
